export default {
  KYC_ONLY: 'kyc_only',
  SIGNUP: 'signup',
  COMBINED: 'combined'
};